import React from 'react';
import classNames from 'classnames';
import { TailSpin } from 'react-loader-spinner';

import * as styles from './Loader.module.scss';

const Loader = (props) => {
    const { className } = props;

    return (
        <div
            className={classNames(
                styles.loaderContainer,
                className,
            )}
        >
            <div className={styles.loader}>
                <TailSpin
                    color="black"
                    width={100}
                    height={100}
                />
            </div>
        </div>
    );
};

export default Loader;
